// extracted by mini-css-extract-plugin
export default {"external":"a8mG3T","grid":"b8mG3T"};